import React from "react";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import AgribusinessStack from "../AgribusinessStack/AgribusinessStack";

// Main component for CBN Deployment for Agri-Retailers
export default function AgriRetailers() {
  return (
    <>
      {/* Banner section */}
      <AgribusinessStack
        classname="agriretailer-bg "
        level1="System Integrator"
        level2="Agribusiness"
        level3="Agri-Retailers"
      />

      {/* Section representing deployment for agri-retailers */}
      <SolutionEcosystem
        title="CBN Deployment for Agri-Retailers"
        type="AR"
        bodycopy="ARN is a type of CBN through which agri-retailers sell quality inputs to the farmers."
      />
    </>
  );
}


